var $ = jQuery;

$(document).on('ready', function(){
    $(document).on('click', '.read-more-btn', function() {
        var index = $(this).attr('index');
        $('.read-more-btn').each(function(i, obj) {
            obj.classList.remove('hide');  
        })
        $(this).addClass('hide');
        $('.benefit-description').each(function(i, obj) {
            obj.classList.remove('show');      
            if(obj.getAttribute('index') == index) {
                if (obj.classList.contains('show')) {
                    obj.classList.remove('show')
                } else {
                    obj.classList.add('show');    
                }  
            }
       })
    })
})
